import React, { useEffect, createRef, useState } from 'react'
import FormInput from './fields/FormInput'
import FormSelect from './fields/FormSelect'

const TermlifeQuoter = ({
  active,
  stateNames,
  tobaccoOptions,
  token,
  componentName,
  task,
  version,
}) => {
  const [values, setValues] = useState({
    amount: '',
    term: '',
    statename: '',
    gender: '',
    mm: '',
    dd: '',
    yyyy: '',
    tobacco: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  })

  const [agreement, setAgreement] = useState(false)

  useEffect(() => {
    console.log({ componentName, task, version, values })
  }, [values])

  const formatAmount = (value) => {
    value = formatValuedAmount(value)
    return value.length > 0 ? '$' + value : ''
  }

  const formLink = `/index.php?option=${componentName}&task=${task}&ins=termlife`

  const terms = [
    { label: 'Select your term', value: '' },
    { label: '10 Years', value: 10 },
    { label: '15 Years', value: 15 },
    { label: '20 Years', value: 20 },
    { label: '25 Years', value: 25 },
    { label: '30 Years', value: 30 },
    { label: '35 Years', value: 35 },
    { label: '40 Years', value: 40 },
  ]

  if (!active) {
    return
  }

  const formatValuedAmount = (a) => {
    return (
      a
        .replace(/\$/g, '')
        .replace(/,/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ''
    )
  }

  const formatTheAmount = (a) => {
    let n = a + ''
    n = n.replace(/\$/g, '')
    n = n.replace(/,/g, '')
    n = parseFloat(n)
    n = n.toFixed(2)
    n = n.toString()
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return n
  }

  function formatMoney(amount) {
    let decimalCount =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0
    let decimal =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.'
    let thousands =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ','
    let symbol =
      arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '$'

    try {
      decimalCount = Math.abs(decimalCount)
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount
      let negativeSign = amount < 0 ? '-' : ''
      let i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString()
      let j = i.length > 3 ? i.length % 3 : 0
      return (
        symbol +
        negativeSign +
        (j ? i.substring(0, j) + thousands : '') +
        i.substring(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')
      )
    } catch (e) {
      console.log(e)
    }
  }

  const clearValueAmount = (a) => {
    return a.replace(/\$/g, '').replace(/,/g, '') + ''
  }

  const onChange = (e, config) => {
    const { name, value } = e.target

    debugger

    if (config && config.validator !== 'undefined') {
      const result = config.validator(e.target.value)
      console.log({ result })
      if (result.success) {
        e.target.setCustomValidity('')
      } else {
        e.target.setCustomValidity(result.message)
      }
    }

    setValues({ ...values, [name]: value })

    console.log({ values })
  }

  const formRef = createRef()
  const agreementCheckboxRef = createRef()

  const onSubmit = (e) => {
    for (const key of Object.getOwnPropertyNames(values)) {
      console.log({ key, value: values[key] })

      if (values[key] !== 'undefined') {
        if (values[key].length < 1) {
          alert('Form is invalid')
          return false
        }
      }
    }

    formRef.submit()
    return true
  }

  const inputs = [
    {
      id: 1,
      name: 'amount',
      type: 'text',
      hint: 'How much do you need?',
      label: 'Face Amount:',
      required: true,
      errorMessage:
        'Please provide a valid amount. Amount must be between 25,000 and 10,000,000.',
      filter: formatAmount,
      updater: onChange,
      placeholder: '25,000 - 10,000,000',
      pattern: '^\\$\\d{1,3}(,\\d{3})*(\\.\\d+)?$',
      validator: function (value) {
        value = clearValueAmount(value)
        value = parseInt(value)

        if (
          Number.isFinite(parseInt(value)) &&
          (value >= 25000 || value <= 10000000)
        ) {
          return { success: true, message: 'Good' }
        } else {
          return {
            success: false,
            message:
              'Please provide a valid amount. Amount must be between 25,000 and 10,000,000',
          }
        }
      },
      containerStyle: 'mb-3 col-md-6',
    },
    {
      id: 2,
      name: 'term',
      type: 'select',
      hint: 'Select the number of years?',
      label: 'Term:',
      errorMessage: 'Please choose a term.',
      required: true,
      updater: onChange,
      validator: (value) => {
        return value.length > 0
          ? { success: true, message: 'Good' }
          : { success: false, message: 'Please choose a term.' }
      },
      containerStyle: 'mb-3 col-md-6',
      items: terms,
      defaultOptionLabel: 'Select your term',
    },
    {
      id: 3,
      name: 'statename',
      type: 'select',
      hint: 'What is your state?',
      label: 'State:',
      errorMessage: 'Please choose a state.',
      required: true,
      updater: onChange,
      validator: (value) => {
        return value.length > 0
          ? { success: true, message: 'Good' }
          : { success: false, message: 'Please choose a state.' }
      },
      containerStyle: 'mb-3 col-md-6',
      items: stateNames,
      defaultOptionLabel: 'Select your state',
    },
    <div className='mb-3 col-md-6'>
      <label htmlFor='lname' className='form-label dz:d-block'>
        Gender: &nbsp;
      </label>
      <div className='form-check form-check-inline'>
        <input
          className='form-check-input'
          type='radio'
          name='gender'
          id='gender-male'
          value='m'
          onChange={(e) => onChange(e, null)}
          checked={values.gender === 'm'}
          required
        />
        <label className='form-check-label' htmlFor='gender-male'>
          Male
        </label>
      </div>
      <div className='form-check form-check-inline'>
        <input
          className='form-check-input'
          type='radio'
          name='gender'
          id='gender-female'
          value='f'
          onChange={(e) => onChange(e, null)}
          checked={values.gender === 'f'}
          required
        />
        <label className='form-check-label' htmlFor='gender-female'>
          Female
        </label>
      </div>
      <div id='emailHelp' className='form-text'>
        What was your gender at birth?
      </div>
      <div className='invalid-feedback'>Gender is required</div>
    </div>,
    <div className='col-md-12 row mb-3'>
      <div className='row'>
        <div className='col-12 col-md-8'>
          <div className='row'>
            <label htmlFor='birthdate' className='form-label'>
              Birthday:
            </label>

            <div className='col'>
              <input
                type='text'
                maxLength='2'
                placeholder='mm'
                name='mm'
                onChange={(e) => onChange(e, null)}
                value={values.mm}
                className='form-control'
                required
              />
            </div>
            <div className='col'>
              <input
                type='text'
                maxLength='2'
                placeholder='dd'
                name='dd'
                onChange={(e) => onChange(e, null)}
                value={values.dd}
                className='form-control'
                required
              />
            </div>
            <div className='col'>
              <input
                type='text'
                maxLength='4'
                placeholder='yyyy'
                name='yyyy'
                onChange={(e) => onChange(e, null)}
                value={values.yyyy}
                className='form-control'
                required
              />
            </div>
          </div>
          <div id='emailHelp' className='form-text'>
            What is your birthdate?
          </div>
          <div className='invalid-feedback'>Birthday is required</div>
        </div>
      </div>
    </div>,
    {
      id: 5,
      name: 'tobacco',
      type: 'select',
      hint: 'Select use of tobacco.',
      label: 'Tobacco Use:',
      errorMessage: 'Please choose tobacco use.',
      required: true,
      updater: onChange,
      validator: (value) => {
        return value.length > 0
          ? { success: true, message: 'Good' }
          : { success: false, message: 'Please choose tobacco use.' }
      },
      containerStyle: 'mb-3 col-md-12',
      items: tobaccoOptions,
      defaultOptionLabel: 'Select your tobacco use',
    },
    {
      id: 6,
      name: 'firstName',
      type: 'text',
      hint: 'What is your first name?',
      label: 'First Name:',
      required: true,
      errorMessage: 'Please provide your first name.',
      updater: onChange,
      validator: (value) => {
        return { success: true, message: 'Good' }
      },
      containerStyle: 'mb-3 col-md-6',
    },
    {
      id: 7,
      name: 'lastName',
      type: 'text',
      hint: 'What is your last name?',
      label: 'Last Name:',
      required: true,
      errorMessage: 'Please provide your last name.',
      updater: onChange,
      validator: (value) => {
        return { success: true, message: 'Good' }
      },
      containerStyle: 'mb-3 col-md-6',
    },
    {
      id: 8,
      name: 'email',
      type: 'email',
      hint: 'What is your email?',
      label: 'Email:',
      required: true,
      errorMessage: 'Please provide a valid email.',
      updater: onChange,
      validator: (value) => {
        return { success: true, message: 'Good' }
      },
      containerStyle: 'mb-3 col-12 col-md-6',
    },
    {
      id: 9,
      name: 'phone',
      type: 'tel',
      hint: 'What is your phone?',
      label: 'Phone:',
      required: true,
      errorMessage: 'Please provide a valid phone number.',
      updater: onChange,
      validator: (value) => {
        return { success: true, message: 'Good' }
      },
      containerStyle: 'mb-3 col-12 col-md-6',
    },
  ]

  return (
    <form
      id='form-quote'
      action={formLink}
      ref={formRef}
      onSubmit={onSubmit}
      method='post'
      className='row form-validate form-horizontal'
    >
      {inputs.map((input) => {
        if (input.type === 'select') {
          return (
            <FormSelect
              key={input.id}
              classes={input.containerStyle}
              {...input}
              name={input.name}
              items={input.items}
              hint={input.hint}
              onChange={(e) => input.updater(e, input)}
            />
          )
        } else if (
          input.type === 'text' ||
          input.type === 'tel' ||
          input.type === 'email'
        ) {
          return (
            <FormInput
              key={input.id}
              {...input}
              name={input.name}
              value={
                input.hasOwnProperty('filter')
                  ? input.filter(values[input.name])
                  : values[input.name]
              }
              onChange={(e) => input.updater(e, input)}
            />
          )
        } else {
          return input
        }
      })}

      <div className='col-12'>
        <p>
          By submitting this request, I consent to receive a phone calls, text
          messages, or email regarding products and services.
        </p>
      </div>

      <div className='col-12'>
        <div className='form-check'>
          <input
            className='form-check-input'
            type='checkbox'
            value={agreement}
            onChange={(e) => setAgreement(e.target.checked)}
            id='flexCheckDefault'
          />
          <label className='form-check-label' htmlFor='flexCheckDefault'>
            I agree
          </label>
        </div>
      </div>

      <div className='control-group'>
        <div className='controls'>
          <button
            type='submit'
            className='validate btn btn-primary'
            disabled={agreement !== true}
          >
            Submit
          </button>
        </div>
      </div>

      <input type='hidden' name='option' value={componentName} />
      <input type='hidden' name='task' value={task} />
      <input type='hidden' name={token} />
    </form>
  )
}

export default TermlifeQuoter
